import { Injectable } from '@angular/core';
import { NavController, MenuController } from '@ionic/angular';
import { User } from '../models/users';
import { ConfigService } from './config.service';
import { ErrorService } from './error.service';
import { LoadingService } from './loading.service';
import { RestService } from './rest.service';
import { ToastService } from './toast.service';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  user: User = new User();
  public lstCourses = [];
  constructor(
    public configProvider: ConfigService,
    public errorProvider: ErrorService,
    public storage: Storage,
    public toast: ToastService,
    public navController: NavController,
    public menu: MenuController,
    public loading: LoadingService,
    public rest: RestService,
  ) {
    this.user = new User();
    this.storage.get('user').then((user: User) => {
      if (user != undefined && user != null) {
        this.user = user;
      }
    });

  }

  middleware() {
    return new Promise((resolve, reject) => {
      this.storage.get('user').then((user: User) => {
        console.log("AuthService",user);
        if (user != undefined && user != null && user.idUser > 0) {
          this.user = user;
          resolve(true);
        } else {
          reject(false);
          this.toast.info('Faça Login para acessar a plataforma');
          this.navController.navigateRoot(['/login'], { animated: true, animationDirection: 'back' });
        }
      });

    });
  }

  login(email: string, password: string) {

    let data = [{ "email": email, "password": password }];

    return new Promise((resolve, reject) => {
      this.rest.post(data, 'Login', '/')
        .then((result: any) => {
          resolve(result);
        },
          (error) => {
            if (error.status == 500) {
              this.errorProvider.erros(50010);
            }
            else {
              this.errorProvider.erros(error.status);
            }
            reject(error);
          });
    });
  }

  register(obj: any) {
    return new Promise((resolve, reject) => {

      // this.http.post(this.configProvider.getURLServe("Register"), JSON.stringify(obj))
      //   .subscribe((result: any) => {
      //     resolve(result);
      //   },
      //     (error) => {
      //       reject(error);
      //     });
    });
  }

  checkCertification(idCurse) {
    return new Promise((resolve) => {

      let data = [];
      data.push(this.user.token);
      data.push({ idUser: this.user.idUser, idCurse: idCurse });

      this.rest.post(data, 'Courses', 'checkCertification').then((res: boolean) => {
        if (res) {
          resolve(true);
        } else {
          resolve(false);
        }

      }, (err) => {
        resolve(false);
        console.log(err);
      });
    });
  }

  logout() {
    this.storage.ready().then(() => {
      this.user = new User();
      this.storage.set('user', null);
      this.storage.remove('user');
      this.storage.clear();
    });

    this.menu.enable(false);
    this.navController.navigateRoot(['/login'], { animated: true, animationDirection: 'back' });
  }

}
